/**
 * Normalize store product image URLs for display (primary + optional second).
 */
export function getStoreProductImageUrls(product) {
  if (!product || typeof product !== 'object') return [];
  const u1 = typeof product.image_url === 'string' ? product.image_url.trim() : '';
  const u2 = typeof product.image_url_2 === 'string' ? product.image_url_2.trim() : '';
  const out = [];
  if (u1) out.push(u1);
  if (u2) out.push(u2);
  return out;
}
